import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { selectSection } from 'actions/template'
import {
	Button,
	// Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	FormControlLabel,
	Grid,
	Switch,
	withMobileDialog,
	withStyles,
} from '@material-ui/core'
import Variables from 'components/TemplateForm/Variables/Variables'
import { Delete } from '@material-ui/icons'
import { removeSection } from 'actions/template'
import { clickCodeButton } from 'actions/template'
import CodeEditor from 'components/TemplateForm/CodeEditor'
import Field from 'components/theme/Field'
import { setImageDimension, setImageSize, setImage } from 'actions/template'

const styles = (theme) => ({
	paperFullWidth: { height: '100%' },
	dialogContentRoot: {
		padding: 0,
		'&:first-child': {
			paddingTop: 0,
		},
		// [theme.breakpoints.down('sm')]: {
		//   padding: 0,
		//   paddingTop: 0,
		// },
	},
	rounded: {
		borderRadius: 28,
		[theme.breakpoints.down('sm')]: {
			borderRadius: 0,
		},
	},
	widthAndHeight: {
		padding: '0 10px',
		// [theme.breakpoints.down('md')]: {
		// 	padding: '0 50px',
		// },
	},
})

const editorMap = {
  wysiwyg: 'wysiwyg',
  header: 'wysiwyg',
  divider: 'wysiwyg',
  paragraph: 'wysiwyg',
  'image-paragraph': 'wysiwyg',
  '2-columns-image-paragraph': 'wysiwyg',
  '3-columns-image-paragraph': 'wysiwyg',
  'image-banner-text': 'wysiwyg',
}

class EditorDialog extends Component {
	componentDidUpdate(prevProps) {
		if (
			prevProps.sectionSelected !== this.props.sectionSelected &&
			!this.props.sectionSelected &&
			this.props.codeEditorDisplayed
		) {
			this.props.clickCodeButton()
		}
	}

	render() {
		return (
      <Dialog
        fullWidth
        maxWidth="xl"
        fullScreen={this.props.fullScreen}
        open={this.props.sectionSelected !== null}
        // open={false}
        onClose={() => this.props.selectSection(null)}
        classes={{
          paperFullWidth: this.props.classes.paperFullWidth,
        }}
        PaperProps={{ classes: { rounded: this.props.classes.rounded } }}
      >
        <DialogContent
          classes={{
            root: this.props.classes.dialogContentRoot,
          }}
        >
          {this.props.codeEditorDisplayed ? <CodeEditor /> : <Variables />}
          {this.props.editor === 'img-picker' && (
            <>
              <div className={this.props.classes.widthAndHeight}>
                <div
                  style={{
                    width: '50%',
                    display: 'inline-block',
                    padding: '0 5px',
                  }}
                >
                  <Field
                    label="Width px (max: 600)"
                    property="width"
                    // handleChangeFuncPath="actions/template"
                    // handleChangeFunc="setImageDimension"
                    handleChange={this.props.setImageDimension}
                    valuePath={state => state.email.image.width}
                  />
                </div>
                <div
                  style={{
                    width: '50%',
                    display: 'inline-block',
                    padding: '0 5px',
                  }}
                >
                  <Field
                    label="Height px"
                    property="height"
                    // handleChangeFuncPath="actions/template"
                    // handleChangeFunc="setImageDimension"
                    handleChange={this.props.setImageDimension}
                    valuePath={state => state.email.image.height}
                  />
                </div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <FormControlLabel
                  label="Keep image proportions"
                  control={
                    <Switch
                      checked={this.props.checked}
                      onChange={e => {
                        console.log(e.target.checked)
                        this.props.setImageDimension('fixed', e.target.checked)
                      }}
                    />
                  }
                />
              </div>
              {/* <em
							style={{
								textAlign: 'center',
							}}
						>
							Please pick an image above to insert into your template.
						</em> */}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Grid container justify="space-between">
            <Grid item>
              {editorMap?.[this.props.editor] === 'wysiwyg' && (
                <Button onClick={() => this.props.clickCodeButton()}>
                  {this.props.codeEditorDisplayed
                    ? 'Edit Section'
                    : 'Edit code'}
                </Button>
              )}
            </Grid>
            <Grid item>
              <Button
                onClick={() =>
                  window.confirm(
                    'Are you sure you want to delete this section?',
                  ) && this.props.removeSection(this.props.sectionSelected)
                }
                color="primary"
              >
                <Delete
                  style={{
                    marginRight: 5,
                  }}
                />
                Delete
              </Button>
              <Button
                onClick={() => {
                  if (this.props.editor === 'img-picker') {
                    this.props.setImage()
                  } else {
                    this.props.selectSection(null)
                  }
                }}
                color="primary"
              >
                Close
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    )
	}
}

export default connect(
	(state) => ({
		codeEditorDisplayed: state.email.codeEditorDisplayed,
		sectionSelected: state.email.sectionSelected,
		editor:
			typeof state.email.sectionSelected === 'number' &&
			state.email.sections[state.email.sectionSelected] &&
			state.email.sections[state.email.sectionSelected].editor,
		checked: state.email.image.fixed,
	}),
	(dispatch) =>
		bindActionCreators(
			{
				selectSection,
				removeSection,
				clickCodeButton,
				setImageDimension,
				setImageSize,
				setImage,
			},
			dispatch,
		),
)(withMobileDialog()(withStyles(styles)(EditorDialog)))
